/* tslint:disable:typedef-whitespace no-trailing-whitespace */
// noinspection CssUnknownTarget

import {TaskUpdate, TaskUpdateType} from "@/models/task.update";

/**
 *
 * @class TaskUpdateFileFolderDeleteFailed
 *
 * @brief sentinel progress event; we failed to delete a file or folder in a batch delete
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
export class TaskUpdateFileFolderDeleteFailed extends TaskUpdate {

  /** the error message */
  public message: string;

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id       the unique id of the task progress stream to clear (the context)
   * @param message  the error message
   *
   */
  constructor(id: string, message: string) {

    super(id, TaskUpdateType.Complete,100.0);

    this.message  = this.errorToString(message);
  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    return `
<div class="task-file-upload-sub-panel">

  <div style="display: inline-block; width: 32px;">
    <span class="tsp-icon" style="width: 32px; height: 32px; background-color: #9e0000; -webkit-mask-image: url(/assets/images/uncheck-64.png); -webkit-mask-size: 32px 32px; mask-size: 32px 32px; mask-image: url('/assets/images/uncheck-64.png'); background-size: contain;"></span>
  </div>

  <div style="display: inline-block; width: calc(100% - 40px);">

    <div style="display: block;">
      <span class="tsp-label">${this.message}</span>
    </div>

  </div>

</div>`;
  }

  /** is this task complete? */
  isComplete(): boolean {

    return true;
  }

}
